import React from "react";
import PropTypes from "prop-types";

import Filter from "../../../Filter";
import { UIButton } from "../../../ui";

import "./EventTimesheet.scss";

const EventTimesheetToolbar = ({
  copy,
  search,
  onSearchChange,
  onExportAll,
  exportDisabled,
  showExportAll = true,
  filters,
  roleOptions,
  statusOptions,
  onFilterChange,
  renderActionBeforeFilter,
}) => (
  <Filter
    isCollapsable
    searchInput={{
      placeholder: copy.searchPlaceholder,
      name: "search",
      value: search,
      onChange: onSearchChange,
    }}
    classNames={{
      root: "event-timesheet__toolbar",
      search: "event-timesheet__search",
    }}
    renderActionBeforeFilterToggle={
      <div className="event-timesheet__toolbar-actions d-flex align-items-center gap-3">
        {renderActionBeforeFilter}
        {showExportAll ? (
          <UIButton
            type="button"
            variant="primary"
            size="large"
            appearance="outline"
            disabled={exportDisabled}
            onClick={onExportAll}
            className="event-timesheet__export-btn"
          >
            {copy.exportAll}
          </UIButton>
        ) : null}
      </div>
    }
    filters={[
      {
        type: "filter",
        name: "role",
        placeholder: copy.applicantRole,
        value: filters.role,
        options: roleOptions,
        onChange: (value) => onFilterChange({ role: value || null }),
      },
      {
        type: "filter",
        name: "status",
        placeholder: copy.applicantStatus,
        value: filters.status,
        options: statusOptions,
        onChange: (value) => onFilterChange({ status: value || null }),
      },
    ]}
  />
);

EventTimesheetToolbar.propTypes = {
  copy: PropTypes.object.isRequired,
  search: PropTypes.string,
  onSearchChange: PropTypes.func.isRequired,
  onExportAll: PropTypes.func,
  exportDisabled: PropTypes.bool,
  showExportAll: PropTypes.bool,
  filters: PropTypes.shape({
    role: PropTypes.object,
    status: PropTypes.object,
  }),
  roleOptions: PropTypes.array,
  statusOptions: PropTypes.array,
  onFilterChange: PropTypes.func.isRequired,
  renderActionBeforeFilter: PropTypes.node,
};

EventTimesheetToolbar.defaultProps = {
  search: "",
  onExportAll: undefined,
  exportDisabled: true,
  showExportAll: true,
  filters: {},
  roleOptions: [],
  statusOptions: [],
  renderActionBeforeFilter: null,
};

export default EventTimesheetToolbar;
